import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import FlashAlert from "../../Components/FlashAlert/FlashAlert";
import apiService from "../../services/api.service";

const DashboardEndEvents = () => {
  const [eventId, setEventId] = useState("");
  const [eventToEnd, setEventToEnd] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [lookingUp, setLookingUp] = useState(false);
  const [ending, setEnding] = useState(false);

  const closeConfirm = () => {
    if (ending) return;
    setEventToEnd(null);
  };

  const handleLookup = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const id = Number(eventId);
    if (!id) {
      setError("Inserisci un ID evento valido.");
      return;
    }
    setLookingUp(true);
    try {
      const response = await apiService.getEvents();
      const event = (response.data || []).find((item) => Number(item.id) === id);
      if (!event) {
        setError("Evento non trovato.");
        return;
      }
      if (event.finished) {
        setError("Questo evento è già terminato.");
        return;
      }
      setEventToEnd(event);
    } catch (err) {
      const status = err.response?.status;
      if (status === 404) {
        setError("Evento non trovato.");
      } else if (status === 403) {
        setError("Non puoi terminare questo evento.");
      } else {
        setError(err.response?.data?.detail || "Impossibile verificare l'evento.");
      }
    } finally {
      setLookingUp(false);
    }
  };

  const handleEnd = async () => {
    if (!eventToEnd) return;
    setEnding(true);
    setError("");
    setSuccess("");
    try {
      await apiService.endEvent(eventToEnd.id);
      setSuccess(`Evento "${eventToEnd.name}" terminato. Ora risulta tra gli eventi passati e non è più visibile in home.`);
      setEventToEnd(null);
      setEventId("");
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      if (status === 404) {
        setError("Evento non trovato.");
      } else if (status === 403) {
        setError("Non puoi terminare questo evento.");
      } else if (status === 409) {
        setError(detail || "Questo evento è già terminato.");
      } else {
        setError(detail || "Terminazione non riuscita.");
      }
      setEventToEnd(null);
    } finally {
      setEnding(false);
    }
  };

  return (
    <div className="dashboard-card">
      <h1 className="dashboard-card__title">Termina evento</h1>
      <p className="dashboard-card__subtitle">
        Inserisci l&apos;ID dell&apos;evento da terminare. L&apos;evento verrà spostato in Eventi passati e non sarà più mostrato nella home dell&apos;applicazione.
      </p>

      {error && <FlashAlert variant="danger" onHidden={() => setError("")}>{error}</FlashAlert>}
      {success && <FlashAlert variant="success" onHidden={() => setSuccess("")}>{success}</FlashAlert>}

      <Form onSubmit={handleLookup} style={{ maxWidth: 420 }}>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="end-event-id">ID evento</Form.Label>
          <Form.Control
            id="end-event-id"
            value={eventId}
            onChange={(e) => setEventId(e.target.value.replace(/\D/g, ""))}
            inputMode="numeric"
            placeholder="Es. 42"
            autoComplete="off"
          />
        </Form.Group>
        <Button type="submit" className="users-edit-btn" disabled={lookingUp || !eventId.trim()}>
          {lookingUp ? "Verifica..." : "Termina evento"}
        </Button>
      </Form>

      <Modal show={Boolean(eventToEnd)} onHide={closeConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>Termina evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Vuoi terminare <strong>{eventToEnd?.name}</strong> (ID {eventToEnd?.id})? L&apos;evento sparirà dalla home e comparirà tra gli eventi passati.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeConfirm} disabled={ending}>Annulla</Button>
          <Button variant="danger" onClick={handleEnd} disabled={ending}>
            {ending ? "Terminazione..." : "Termina"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardEndEvents;
